import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChamadoStatus } from 'src/app/shared/interfaces/chamado/chamado-status.interface';
import { ChamadosNaoVisualizados } from 'src/app/shared/interfaces/chamado/chamado.interface';
import { FiltroIndicadorChamado, IndicadorChamado } from 'src/app/shared/interfaces/chamado/indicador-chamado.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChamadoAPIService {

  private baseUrl = `${environment.APIEndpoint}chamado`;

  constructor(private http: HttpClient) { }

  getAll(pageNumber: number = 1, pageSize: number = 100, nome: string = null, id: number = null, mostrarTodos: boolean = null, departamentoResponsavelId: number = null, tipoChamadoId: number = null, usuarioCriacaoId: number = null, dataCriacaoInicio: string = null, dataCriacaoFinal: string = null,
    extras?: { statusIds?: number[], emAtraso?: boolean, departamentoIds?: number[], tipoIds?: number[], usuarioResponsavelIds?: number[], usuarioCriacaoIds?: number[], prioridades?: number[] }) {
    var queryStatus = "";
    if(nome != null && nome != undefined)
      queryStatus += `&nome=${nome}`;

    if(id != null && id != undefined)
      queryStatus += `&id=${id}`;

    if(mostrarTodos != null && mostrarTodos != undefined)
      queryStatus += `&todosChamados=${mostrarTodos}`;

    if (departamentoResponsavelId != null && departamentoResponsavelId != undefined)
      queryStatus += `&departamentoResponsavelId=${departamentoResponsavelId}`;

    if (tipoChamadoId != null && tipoChamadoId != undefined)
      queryStatus += `&tipoChamadoId=${tipoChamadoId}`;

    if (usuarioCriacaoId != null && usuarioCriacaoId != undefined)
      queryStatus += `&usuarioCriacaoId=${usuarioCriacaoId}`;

    if (dataCriacaoInicio != null && dataCriacaoInicio != undefined)
      queryStatus += `&dataCriacaoInicio=${dataCriacaoInicio}`;

    if (dataCriacaoFinal != null && dataCriacaoFinal != undefined)
      queryStatus += `&dataCriacaoFinal=${dataCriacaoFinal}`;

    // Filtros estendidos (drill-down dos indicadores): cada valor de array vira
    // um parâmetro repetido, casando com os nomes esperados pelo controller.
    if (extras) {
      (extras.statusIds || []).forEach(v => queryStatus += `&statusId=${v}`);
      (extras.departamentoIds || []).forEach(v => queryStatus += `&departamentoId=${v}`);
      (extras.tipoIds || []).forEach(v => queryStatus += `&tipoChamadoIds=${v}`);
      (extras.usuarioResponsavelIds || []).forEach(v => queryStatus += `&usuarioResponsavelId=${v}`);
      (extras.usuarioCriacaoIds || []).forEach(v => queryStatus += `&usuarioCriacaoIds=${v}`);
      (extras.prioridades || []).forEach(v => queryStatus += `&prioridade=${v}`);
      if (extras.emAtraso) queryStatus += `&emAtraso=true`;
    }

    var queryParams = `/listar-paginada?pageNumber=${pageNumber}&pageSize=${pageSize}${queryStatus}`;

    return this.http.get(this.baseUrl + queryParams);
  }

    getMeusChamados(pageNumber: number = 1, pageSize: number = 100, nome: string = null, id: number = null, mostrarTodos: boolean = null, departamentoResponsavelId: number = null, tipoChamadoId: number = null, usuarioCriacaoId: number = null, dataCriacaoInicio: string = null, dataCriacaoFinal: string = null) {
    var queryStatus = "";
    if(nome != null && nome != undefined)
      queryStatus += `&nome=${nome}`;

    if(id != null && id != undefined)
      queryStatus += `&id=${id}`;

    if(mostrarTodos != null && mostrarTodos != undefined)
      queryStatus += `&todosChamados=${mostrarTodos}`;  

    if (departamentoResponsavelId != null && departamentoResponsavelId != undefined)
      queryStatus += `&departamentoResponsavelId=${departamentoResponsavelId}`;

    if (tipoChamadoId != null && tipoChamadoId != undefined)
      queryStatus += `&tipoChamadoId=${tipoChamadoId}`;

    if (usuarioCriacaoId != null && usuarioCriacaoId != undefined)
      queryStatus += `&usuarioCriacaoId=${usuarioCriacaoId}`;

    if (dataCriacaoInicio != null && dataCriacaoInicio != undefined)
      queryStatus += `&dataCriacaoInicio=${dataCriacaoInicio}`;

    if (dataCriacaoFinal != null && dataCriacaoFinal != undefined)
      queryStatus += `&dataCriacaoFinal=${dataCriacaoFinal}`;

    var queryParams = `/listar-meus-chamados-paginada?pageNumber=${pageNumber}&pageSize=${pageSize}${queryStatus}`;
    return this.http.get(this.baseUrl + queryParams);
  }

    getMeusAtendimentos(pageNumber: number = 1, pageSize: number = 100, nome: string = null, id: number = null, mostrarTodos: boolean = null, departamentoResponsavelId: number = null, tipoChamadoId: number = null, usuarioCriacaoId: number = null, dataCriacaoInicio: string = null, dataCriacaoFinal: string = null) {
    var queryStatus = "";
    if(nome != null && nome != undefined)
      queryStatus += `&nome=${nome}`;

    if(id != null && id != undefined)
      queryStatus += `&id=${id}`;

    if(mostrarTodos != null && mostrarTodos != undefined)
      queryStatus += `&todosChamados=${mostrarTodos}`;  

    if (departamentoResponsavelId != null && departamentoResponsavelId != undefined)
      queryStatus += `&departamentoResponsavelId=${departamentoResponsavelId}`;

    if (tipoChamadoId != null && tipoChamadoId != undefined)
      queryStatus += `&tipoChamadoId=${tipoChamadoId}`;

    if (usuarioCriacaoId != null && usuarioCriacaoId != undefined)
      queryStatus += `&usuarioCriacaoId=${usuarioCriacaoId}`;

    if (dataCriacaoInicio != null && dataCriacaoInicio != undefined)
      queryStatus += `&dataCriacaoInicio=${dataCriacaoInicio}`;

    if (dataCriacaoFinal != null && dataCriacaoFinal != undefined)
      queryStatus += `&dataCriacaoFinal=${dataCriacaoFinal}`;

    var queryParams = `/listar-meus-atendimentos-paginada?pageNumber=${pageNumber}&pageSize=${pageSize}${queryStatus}`;
    return this.http.get(this.baseUrl + queryParams);
  }

  getMinhasAprovacoes(pageNumber: number = 1, pageSize: number = 100, nome: string = null, id: number = null, mostrarTodos: boolean = null, departamentoResponsavelId: number = null, tipoChamadoId: number = null, usuarioCriacaoId: number = null, dataCriacaoInicio: string = null, dataCriacaoFinal: string = null) {
    var queryStatus = "";
    if(nome != null && nome != undefined)
      queryStatus += `&nome=${nome}`;

    if(id != null && id != undefined)
      queryStatus += `&id=${id}`;

    if(mostrarTodos != null && mostrarTodos != undefined)
      queryStatus += `&todosChamados=${mostrarTodos}`;  

    if (departamentoResponsavelId != null && departamentoResponsavelId != undefined)
      queryStatus += `&departamentoResponsavelId=${departamentoResponsavelId}`;

    if (tipoChamadoId != null && tipoChamadoId != undefined)
      queryStatus += `&tipoChamadoId=${tipoChamadoId}`;

    if (usuarioCriacaoId != null && usuarioCriacaoId != undefined)
      queryStatus += `&usuarioCriacaoId=${usuarioCriacaoId}`;

    if (dataCriacaoInicio != null && dataCriacaoInicio != undefined)
      queryStatus += `&dataCriacaoInicio=${dataCriacaoInicio}`;

    if (dataCriacaoFinal != null && dataCriacaoFinal != undefined)
      queryStatus += `&dataCriacaoFinal=${dataCriacaoFinal}`;

    var queryParams = `/listar-minhas-aprovacoes-paginada?pageNumber=${pageNumber}&pageSize=${pageSize}${queryStatus}`;
    return this.http.get(this.baseUrl + queryParams);
  }

  getTiposPorSetor(setorId: number) {
    return this.http.get(this.baseUrl + `/${setorId}/tipos`);
  }

  adicionarTipoChamado(data: any ){
    return this.http.post(this.baseUrl + "/chamado-tipo", data);
  }

  getTiposPorDepartamento(departamentoId: number) {
    return this.http.get(this.baseUrl + `/${departamentoId}/tipos`);
  }

  /** Painel agregado de indicadores de chamados (cards, gráficos e tabelas). */
  getIndicadores(filtro: FiltroIndicadorChamado): Observable<IndicadorChamado> {
    let params = new HttpParams();
    if (filtro.dataInicio) params = params.set('dataInicio', filtro.dataInicio);
    if (filtro.dataFim) params = params.set('dataFim', filtro.dataFim);
    // Filtros de múltipla seleção: cada valor vira um parâmetro repetido (?statusId=1&statusId=2).
    (filtro.departamentoIds || []).forEach(id => params = params.append('departamentoId', id.toString()));
    (filtro.usuarioResponsavelIds || []).forEach(id => params = params.append('usuarioResponsavelId', id.toString()));
    (filtro.chamadoTipoIds || []).forEach(id => params = params.append('chamadoTipoId', id.toString()));
    (filtro.statusIds || []).forEach(id => params = params.append('statusId', id.toString()));
    (filtro.prioridades || []).forEach(p => params = params.append('prioridade', p.toString()));
    (filtro.usuarioSolicitanteIds || []).forEach(id => params = params.append('usuarioSolicitanteId', id.toString()));

    return this.http.get<IndicadorChamado>(`${this.baseUrl}/indicadores`, { params });
  }

  /** Lista de status de chamado (para dropdowns/filtros). */
  getStatus(): Observable<ChamadoStatus[]> {
    return this.http.get<ChamadoStatus[]>(`${this.baseUrl}/status`);
  }

  /** Departamentos em que o usuário logado é aprovador (filtro dos indicadores). */
  getDepartamentosIndicador(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/indicadores/departamentos`);
  }

  /*
  getStatus(id: number): Observable<ChamadoStatus[]> {
    return this.http.get<ChamadoStatus[]>(this.baseUrl + `/status/${id}`);
  } */

  /**
   * Totais das filas de chamado do usuário logado, para o badge do menu.
   * O usuário sai do token — não se passa id, justamente para o contador
   * nunca ser o de outra pessoa.
   */
  getMeusTotais(): Observable<ChamadosNaoVisualizados> {
    return this.http.get<ChamadosNaoVisualizados>(`${this.baseUrl}/meus-totais`);
  }

  getById(id: number) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  getChamadoServicoById(id: number) {
    return this.http.get(`${this.baseUrl}/chamado/${id}`);
  }

  getHistoricoChamado(chamadoId: number) {
    return this.http.get(`${this.baseUrl}/${chamadoId}/historico`);
  }

  create(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  update(id: number, data: any) {
    return this.http.put(`${this.baseUrl}/${id}`, data);
  }

  redirecionarDepartamento(id: number, departamentoId: number) {
    return this.http.put(`${this.baseUrl}/redirecionar-departamento/${id}`, { id, departamentoId });
  }

  delete(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
  
}
